<!--2022 樱花专题-->
<template>
<div class="spring">
    <div class="top-head">
        <div class="warrp">
            <a target="_blank" href="//yorkbbs.ca" class="logo">YorkBBS.CA</a>
            <div class="flex-cont"></div>
            <div class="nav">
                <a target="_blank" href="//yorkbbs.ca">网站首页</a>
                <a target="_blank" href="//news.yorkbbs.ca">新闻</a>
                <a target="_blank" href="//forum.yorkbbs.ca">论坛</a>
            </div>
        </div>
    </div>
    <div class="banner" ref="banner">
        <div class="pc-banenr" :style="{'background-image':'url('+require('./assets/pc-banner-bg.png')+')'}">
            
            <img :src="require('./assets/pc-banner.png')" class="" alt="">
        </div>
        <div class="media-banner "><img :src="require('./assets/m-banner.png')" alt=""></div>
    </div>

    <!--顶部 专题引言-->
    <div class="introduction">
        <div class="top-quotes"><img :src="require('./assets/top-quotes.png')" alt=""></div>
        <div class="flex-cont ">
            9月开学季，约克论坛与您一起奔赴人生道路的每一个新起点，新目标。在这里许下对学习、对工作、对人生新的展望，冲鸭！我们永远都是勇敢的少年~
            <img :src="require('./assets/down-quotes.png')" alt="">
        </div>
    </div>
    <SaleBanner />
    <!--为你推荐-->
    <div class="blk-cont recommend">
        <div class="blk-title"><strong>为你推荐</strong></div>
        <Recommend />
    </div>
    <div class="nav-list-cont">
        <div class="nav-list">
            <div class="item"><a href="https://news.yorkbbs.ca/detail/house/d9ca9ba0-0ad7-4195-9758-df81640a0b36" target="_blank">
                <img class="default" :src="require('./assets/nav-1.png')" alt="">
                <img class="media" :src="require('./assets/nav-1-1.png')" alt="">
            </a></div>
            <div class="item"><a href="https://news.yorkbbs.ca/detail/house/06d5ad88-6f7d-4051-bcad-21fca6a1fb78" target="_blank">
                <img class="default" :src="require('./assets/nav-2.png')" alt="">
                <img class="media" :src="require('./assets/nav-2-1.png')" alt="">
            </a></div>
            <div class="item"><a href="https://news.yorkbbs.ca/detail/house/512d11ef-f58d-4ea6-afb5-bf473b183fb8" target="_blank">
                <img class="default" :src="require('./assets/nav-3.png')" alt="">
                <img class="media" :src="require('./assets/nav-3-1.png')" alt="">
            </a></div>
        </div>
    </div>
    <!--返校优惠-->
    <div class="blk-cont">
        <div class="blk-title"><strong>Back to school优惠</strong></div>
        <BackSchoolSale />
    </div>
    <!--网络优惠-->
    <div class="blk-cont">
        <div class="blk-title"><strong>网络优惠</strong></div>
        <NetSale />
    </div>
    <!-- 热门话题 -->
    <HotSubject />
    <!--类型选择-->
    <div class="tab-style">
        <div class="item" :class="{active:type==0}" @click="typeChange(0)">精选</div>
        <div class="item" :class="{active:type==1}" @click="typeChange(1)">点赞最多</div>
        <div class="item" :class="{active:type==2}" @click="typeChange(2)">最新发布 </div>
    </div>

    <!---列表展示-->
    <div class="post-list">
        <ItemSubject v-for="item in list" :key="item.id" :data="item" />
    </div>


    <!--操作按钮-->
    <div class="join-play">
        <div class="box">
            <a :href="'/publish/edu?subject=bd0f46d4-687b-466b-b880-21abd53cd5fb'|hostBuild('forum')" target="_blank"> 参与话题</a>
        </div>

    </div>
    

    <FooterWhite></FooterWhite> 
    <div style="height:100px"></div>

    <div class="play-detail"><a :href="'/detail/d71ee60f-b64d-4ad7-8070-373b3cf984a4?topic=recycle'|hostBuild('forum')" target="_blank"><img width="70" :src="require('./assets/play-detail.png')" alt=""></a></div>

    <LeftShare style="left:50%" topic="bd0f46d4-687b-466b-b880-21abd53cd5fb" v-show="showFunc" />
</div>
</template>
<script>
import { throttle } from 'throttle-debounce';
import FooterWhite from '@/components/footer-white.vue'
import ItemSubject from './item-subject.vue'
import LeftShare from '@/components/left-share.vue'
import { isScrollToPageBottom, inflowAdvConvert } from '@/utils/utils';
import Recommend from './recommend.vue'
import BackSchoolSale from './back-school-sale.vue'
import HotSubject from './hot-subject.vue'
import NetSale from './net-sale.vue'
import SaleBanner from './sale-banner.vue'
export default {
    name:'BeginSchool',
    components:{FooterWhite,ItemSubject,LeftShare,Recommend,BackSchoolSale,HotSubject,NetSale,SaleBanner},
    data(){
        return  {
            type:0,
            listLoading:false,
            params:{   
                "offset": 1,
                "size": 10,
                //"sort": ["property_thumbUpTotal: DESC","property_updatedAt: DESC"],
                "sort":['property_commentedAt: DESC'],
                "subject": [
                    "bd0f46d4-687b-466b-b880-21abd53cd5fb"
                ],
                "options":{"elite":[1]},    
            },
            list:[],
            pageComplete:false,
            hasMore:true,
            showFunc:false,//显示功能区
        }
    },
    created(){
        this.getList();
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        shareFun(){
            if( window.navigator.canShare && window.navigator.canShare({url:window.location.origin})){
                navigator.share({
                    title:'这个是title',
                    text:'这个是text字段，看有什么用',
                    url:window.location.origin,
                //text:'这个是text字段，看有什么用'
                })
                .then((res) => {
                console.log(res)
                })
            }
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
             
            let banner = this.$refs['banner'].scrollHeight;
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            if( top>banner-100){
                this.showFunc = true;
            }else{
                this.showFunc = false;
            }
 
            /* const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            const offsetTop = this.$refs.tab.offsetTop;
            this.tabFixed = scrollTop >= offsetTop; */
        }),
        typeChange(index){
            if( this.type == index) return false;
            delete this.params.options;
            if( index == 0 ){
                this.params.sort = ['property_commentedAt: DESC'];
                this.params['options'] = {"elite":[1]};
            }
            if( index ==1 ){
                this.params.sort = ['property_thumbUpTotal: DESC'];
            }
            if( index == 2 ){
                this.params.sort = ['property_commentedAt: DESC'];
            }
            this.type = index;
            this.params.offset = 1;
            this.getList();
  
        },
        async getList(){
            this.listLoading = true;
            let result = await this.$axios.post('/bbs/v1/get/post/list/for/subject',this.params);
            this.pageComplete = true;
            this.listLoading = false;
            if( result.code == 0 ){
          
                if( this.params.offset == 1 ){
                    this.list = [];
                }
                this.list = this.list.concat(result.data.items);
                this.hasMore = (result.data.items.length == this.params.size) && (result.data.pageTotal != this.params.offset);
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/css/tax.css';
.spring{
    background-color: #f8f8f8;
}
/* @media screen and (min-width:768px) {
    .spring{
        
        background-image:url('./assets/pendant-l.png'),url('./assets/pendant-r.png');
        background-position: left 660px, right 760px;
        background-repeat: repeat-y, repeat-y;
    }
} */

.top-head{
    position: absolute; left: 0; top: 0; right: 0; background: rgba(0,0,0,0.10);
    .warrp{
        display: flex; align-items: center; padding: 0 15px; height: 40px;
        .logo{font-size: 16px; line-height: 40px; color: #fff; font-weight: bold;}
        .flex-cont{flex:1;}
        .nav{
            display: flex; align-items: center;
            a{
                font-size: 14px; line-height: 20px; color: #fff; text-decoration: none;margin-left:20px;
                &:hover{text-decoration: underline;}
            }
        }
    }
}
.pc-banenr{display: none;}
.media-banner {display: block;}
@media screen and (min-width:768px){
    .top-head{
        .warrp{max-width: 1170px; margin:0 auto;}
    } 
    .pc-banenr{display: block; background-position:center top ;
        img{display: block; margin:0 auto}
    }
    .media-banner {display: none;}
}


/**开始引言部分 */
.introduction{
    margin: 20px 15px ; background: #fff; border-radius: 10px;  padding: 15px 10px;display: flex;
     img{width: 10px;}
   .top-quotes{margin:5px 5px 0 0;
       
    }
    .flex-cont{
        flex:1; overflow: hidden; font-size: 13px; line-height: 22px;
        img{display: inline-block; margin-top: -10px; margin-left: 10px;}
    }
}
@media screen and (min-width:768px){
    .introduction{
        padding: 30px; margin:0 auto 0; max-width: 800px;border-radius: 20px;transform: translateY(-50%);
         img{width: 20px;}
        .top-quotes{margin-right: 10px;
           
        }
        .flex-cont{
            flex:1; overflow: hidden; font-size: 18px; line-height: 30px;
            img{display: inline-block; margin-top: -10px; margin-left: 10px;}
        }
    }
}

.radius20{border-radius: 20px;}



.tab-style{
    display: flex; align-items: center; justify-content: center; margin-bottom: 15px !important; z-index: 10;
    .item{
        font-size: 14px; line-height: 24px; margin-right: 40px; color: #666; user-select: none; cursor: pointer;
        &:last-child{margin-right: 0;}
        &.active{
            position: relative; font-weight: bold; z-index: 10; font-size: 18px; color: #111;
            &:after{
                position: absolute; content: ''; z-index: -1; left: 0; bottom: 0; right: 0; height: 7px; background: #FF8253 !important;
            }
        }
    }

}
@media screen and (min-width:768px){
    .tab-style{
        display: flex; align-items: center; justify-content: center; margin-bottom: 30px !important;
        .item{
            font-size: 18px; line-height: 37px; margin-right: 40px; user-select: none; cursor: pointer;
            &:last-child{margin-right: 0;}
            &.active{
                position: relative; font-weight: bold; font-size: 26px;
                &:after{
                    position: absolute; content: ''; left: 0; bottom: 0; right: 0; height: 7px; background: #fa4a83;
                }
            }
        }

    }
}

.post-list{
    margin: 0 15px;overflow: hidden;
}
@media screen and (min-width:768px) {
    .post-list{

        max-width: 800px; margin: 0 auto; padding: 0 15px;
    }
}
@media screen and (min-width:992px){
    .post-list{padding: 0;}
}
.blk-cont{
    padding: 15px 20px;
    background: #fff;
    border-radius: 20px;
    margin:0 15px 20px;
    
    .blk-title{margin-bottom: 20px;}
}
@media screen and (min-width:768px) {
    .blk-cont{

        max-width: 800px; margin: 0 auto 20px; padding: 20px 45px 0;
    }
}
/**参加活动按钮 */
.join-play{
    position: fixed; z-index: 100; left: 15px; right: 15px; bottom: 25px;
    .box{
        display: flex; align-items: center; background: #ff7037; height: 40px; font-size: 16px; line-height: 24px; justify-content: center; color: #fff; border-radius: 20px; user-select: none; cursor: pointer;
        a{flex:1; display: flex; align-items: center; justify-content: center; height: 40px;}
        i{font-size: 20px; margin-right:5px;}
    }
}
@media screen and (min-width:768px){
    .join-play{
        .box{max-width: 800px; margin: 0 auto; height: 50px; font-size: 20px; border-radius: 25px;
            a{height: 50px;}
            i{font-size: 26px;}
        }
    }
}


/**活动详情 */
@media screen and (max-width:768px){
    .play-detail{
        position: fixed; z-index: 50; bottom: 150px; right: 25px;
        img{width: 45px; height: 45px;}
    }
}

@media screen and (min-width:768px){
    .play-detail{
        position: fixed; z-index: 50; bottom: 200px; left:50%; margin-left: 480px;
        
    }
}

.nav-list-cont{
    margin: 0 15px 20px; overflow: hidden;
    .nav-list{
        margin: 0 -5px; display: flex;
        .item{
            padding: 0 5px; flex:1;
            a{display: block;}
            img{display: block; width:100%}
            .default{display: none;}
        }
    }
}
@media screen and (min-width:768px){
    .recommend{margin-top: -40px;}
    .nav-list-cont{

        max-width: 800px; margin: 0 auto 20px;
        .nav-list{
            margin: 0 -11px;
            .item{
                padding: 0 11px;
                .default{display: block;}
                .media{display: none;}
            }
        }
        
    }
}
</style>